import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from '@emotion/styled';
import { FlexItem as _FlexItem } from 'mineral-ui/Flex';
import MineralUiButton from 'mineral-ui/Button';
import {
  Box,
  Button,
  Flex,
  ToolTip,
} from '..';
import CarrierSelect from './CarrierSelect';
import { signIn, signOut } from '../../modules/user';
import {
  getUserDetails,
  getClient,
} from '../../modules/selectors';
import api from '../../utils/services';
import userManager from '../../utils/userManager';

const propTypes = {
  bootComplete: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  height: PropTypes.string.isRequired,
  sideBarWidth: PropTypes.string.isRequired,
  user: PropTypes.shape({
    agentNpn: PropTypes.string,
    token: PropTypes.string,
    userId: PropTypes.string,
    userRole: PropTypes.string,
  }),
  onSignOut: PropTypes.func,
  client: PropTypes.shape({ clientName: PropTypes.string }),
  onFakeSignIn: PropTypes.func.isRequired,
};
const defaultProps = {
  user: null,
  client: null,
  onSignOut: null,
};

const SignInButtons = styled(MineralUiButton)`
 width: 50%;
`;

// Need the font-size since the height may be based on it (em)
const StickAppBar = styled.div`
  position: fixed;
  top: 0;
  font-size: ${props => props.theme.fontSize_base};
  height: ${props => props.height};
  width: 100%;
  background-color: ${props => props.theme.backgroundColor_themePrimary};
  z-index: 1000;
`;

const FlexItemDark = styled(_FlexItem)({
  backgroundColor: 'rgba(0, 0, 0, 0.12)',
  position: 'relative',
});

const ClientCarrierHolder = styled.div`
  color: white;
  text-align: center;
`;

const fontSizeForClientNameText = ({ size, theme }) => {
  switch (size) {
    case 'h3': return theme.h3_fontSize;
    case 'h4': return theme.h4_fontSize;
    default: return theme.h5_fontSize;
  }
};

const ClientTextBold = styled.span`
  font-size: ${fontSizeForClientNameText};
  font-weight: ${props => props.theme.fontWeight_bold};
  padding-right: 24px; /* Line up with select text due to icon offset */
`;

class AppTopBar extends Component {
  SignInButton = withRouter(() => (
    <>
      <SignInButtons
        fullWidth
        disabled={['staging', 'uat', 'demo', 'production'].includes(process.env.NODE_ENV)}
        onClick={() => userManager.signinRedirect()}
      >
        Sign In
      </SignInButtons>
      {this.SkipSignIn()}
    </>
  ));

  SkipSignIn = () => {
    if (process.env.NODE_ENV === 'local') {
      return (
        <ToolTip content="Use a generic authentication when running locally. Allows for local development without an internet connection.">
          <Button onClick={this.handleFakeSignIn}>Skip Sign In</Button>
        </ToolTip>
      );
    }
    return null;
  };

 handleFakeSignIn = () => {
   const { onFakeSignIn } = this.props;
   api.fakeSignIn()
     .then((data) => {
       onFakeSignIn(data);
     });
 };

  // Sign out button
  SignOutButton = () => {
    const { onSignOut, history, user } = this.props;
    return (
      <Button
        fullWidth
        onClick={() => {
          api.signOut()
            .then(() => {
              userManager.removeUser();
              onSignOut(signOut());
              history.push('/');
            });
        }}
      >
        {`Sign out ${user.agentNpn}`}
      </Button>
    );
  }

  render() {
    const {
      height,
      sideBarWidth,
      user,
      client: { clientName },
      bootComplete,
    } = this.props;
    let clientNameSize = 'h3';

    if (clientName) {
      // Prevent wrapping of text
      // In the future this should be calculated base on the theme font size
      // Have 198px of space, which fits roughly 10 W at h3 and 13 at h4
      if (clientName.length < 11) {
        clientNameSize = 'h3';
      // the clientName above 28 characters and combined length
      // of more than 25 wraps and creates vertical spill over in h4
      } else if (clientName.length < 14) {
        clientNameSize = 'h4';
      } else {
        clientNameSize = 'h5';
      }
    }
    return (
      <StickAppBar height={height}>
        <Box>
          <Flex>
            <FlexItemDark height={height} width={sideBarWidth}>
              <Flex height="100%" alignItems="center" paddingHorizontal="0.5em" marginTop="-2px">
                <Flex.Item grow={1}>
                  <ClientCarrierHolder>
                    {clientName ? (
                      <div>
                        <ClientTextBold size={clientNameSize}>{clientName}</ClientTextBold>
                        <br />
                        { bootComplete && <CarrierSelect /> }
                      </div>
                    ) : <ClientTextBold size="h3">Loading...</ClientTextBold>}
                  </ClientCarrierHolder>
                </Flex.Item>
              </Flex>
            </FlexItemDark>
            {/* Agent Links go in the FlexItem below */}
            <Flex.Item grow={1} />
            <FlexItemDark padding="0.5em" height={height} width={sideBarWidth}>
              {user
                ? <this.SignOutButton />
                : <this.SignInButton />
            }
            </FlexItemDark>
          </Flex>
        </Box>
      </StickAppBar>
    );
  }
}
function mapStateToProps(state) {
  return {
    user: getUserDetails(state),
    client: getClient(state),
    bootComplete: state.bootComplete,
  };
}

const mapDispatchToProps = dispatch => ({
  onSignOut: () => dispatch(signOut()),
  onFakeSignIn: data => dispatch(signIn(data)),
});


AppTopBar.propTypes = propTypes;
AppTopBar.defaultProps = defaultProps;
// Need to rerender on location update so that SignInButton can rerender
// and correctly redirect back to the original page

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppTopBar));
